export const userStatsQueryKeyPrefix = ["user-stats"] as const
export const pagedUserStatsQueryKeyPrefix = ["user-stats-single"] as const
export const statsSampleGateQueryKeyPrefix = ["stats-sample-gate"] as const

interface UserStatsQueryKeyProps {
  fromDate?: number | null
  toDate?: number | null
  dynamoURL: string
  dynamoAccountID: string | number
  userPersonIDParam: string
  userTimezone?: string | null
  type: "user" | "admin"
  selectedUserId: number | null
  isPreviousPeriod?: boolean
}

export function getUserStatsQueryKey({ fromDate, toDate, dynamoURL, dynamoAccountID, userPersonIDParam, userTimezone, type, selectedUserId, isPreviousPeriod = false }: UserStatsQueryKeyProps) {
  return [...userStatsQueryKeyPrefix, fromDate, toDate, dynamoURL, dynamoAccountID, userPersonIDParam, userTimezone, type, selectedUserId, isPreviousPeriod] as const
}

export function getStatsSampleGateQueryKey({ dynamoAccountID, dynamoURL, probeUserPersonIDParam, checkedScope }: { dynamoAccountID: string | number; dynamoURL: string; probeUserPersonIDParam: string; checkedScope: "user" | "account" }) {
  return [...statsSampleGateQueryKeyPrefix, dynamoAccountID, dynamoURL, probeUserPersonIDParam, checkedScope] as const
}

export function getPagedUserStatsQueryKey({ userId, fromDate, toDate, dynamoAccountID, dynamoURL }: { userId: number; fromDate: number | null; toDate: number | null; dynamoAccountID: string | number; dynamoURL: string }) {
  return [...pagedUserStatsQueryKeyPrefix, userId, fromDate, toDate, dynamoAccountID, dynamoURL] as const
}
